import { Pipe, PipeTransform } from '@angular/core';
import { quoteStatusDropdown } from '../consts';

@Pipe({
  name: 'quoteStatusDescription',
  standalone: true
})
export class QuoteStatusDescriptionPipe implements PipeTransform {
  transform(value: string): string {
    // First, map old Open Quote statuses to standard statuses
    const mappedStatus = value;
    
    // Then search in both arrays for the mapped status
    const combined = [...quoteStatusDropdown()];
    const match = combined.find(item => item.id === mappedStatus || item.id === value);
    return match?.description ?? mappedStatus;
  }
}
